import { apiCrm } from '../../../../http';

class PriceCatalogService {
  constructor() {
    this.BASE_URL = '/price-catalogs';
  }

  // Catalog CRUD Operations
  getPriceCatalogs(queryParams) {
    return apiCrm.get(`${this.BASE_URL}/`, {
      params: queryParams
    });
  }

  getPriceCatalogById(id) {
    return apiCrm.get(`${this.BASE_URL}/${id}`);
  }

  createPriceCatalog(data) {
    return apiCrm.post(`${this.BASE_URL}/`, data);
  }

  updatePriceCatalog(catalogId, data) {
    return apiCrm.patch(`${this.BASE_URL}/${catalogId}`, data);
  }

  enableDisablePriceCatalog(id, data) {
    return apiCrm.patch(`${this.BASE_URL}/status/${id}`, data);
  }

  // Product Operations within Catalog
  getProductsByPriceCatalogId(id, showDisabled = true) {
    return apiCrm.get(`${this.BASE_URL}/${id}/products`, {
      params: {
        showDisabled
      }
    });
  }

  getProductsByPriceCatalogsIds(ids) {
    return apiCrm.get(`/products/getByCatalogIds`, {
      params: {
        catalogIds: ids
      }
    });
  }

  addProductsToCatalog(catalogId, data) {
    return apiCrm.post(`${this.BASE_URL}/${catalogId}/products`, {
      products: data
    });
  }

  updateProductPriceInCatalog(catalogId, productId, data) {
    return apiCrm.patch(
      `${this.BASE_URL}/${catalogId}/products/${productId}`,
      data
    );
  }

  enableDisableProductInPriceCatalog(catalogId, productId, data) {
    return apiCrm.patch(
      `${this.BASE_URL}/${catalogId}/products/${productId}/status`,
      data
    );
  }

  // Discount Matrix Operations
  getDiscountMatrixByCatalogId(id) {
    return apiCrm.get(`${this.BASE_URL}/${id}/discounts`);
  }

  updatePriceCatalogDiscountMatrix(catalogId, data) {
    return apiCrm.put(`${this.BASE_URL}/${catalogId}/discounts`, {
      discountMatrix: data
    });
  }

  getCatalogChangesHistory(catalogId) {
    return apiCrm.get(`price-catalog-history-changes/${catalogId}`);
  }

  getAllPriceCatalogs() {
    return apiCrm.get('all-price-catalogs');
  }
}

export default new PriceCatalogService();
